<template>
  <div class="section-box">
    <div class="box-item">
      <div class="left-part">
        <div class="section-box-item" v-html="itemContent"></div>
      </div>
      <div class="right-part selected">
        <div class="section-item-action">
          <label class="">{{ $t("customer.agree.yes") }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SectionBoxConfirm',
  props: {
    itemContent: {
      type: String
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped>

</style>